// export const SET_QUOTATION = "SET_QUOTATION";
// export const SET_QUOTATION_ASKER = "SET_QUOTATION_ASKER";
// export const CLEAR_QUOTATION = "CLEAR_QUOTATION";


export const SET_QUOTATION_ACTIVE_BILLING = "SET_QUOTATION_ACTIVE_BILLING";
export const SET_QUOTATION_ACTIVE_SHIPPING = "SET_QUOTATION_ACTIVE_SHIPPING";

export const SET_QUOTATION_CANCELLED = "SET_QUOTATION_CANCELLED";
export const SET_QUOTATION_CART = "SET_QUOTATION_CART";
export const SET_QUOTATION_CURRENCY = "SET_QUOTATION_CURRENCY";
export const SET_QUOTATION_ENTERPRISE = "SET_QUOTATION_ENTERPRISE";
export const SET_QUOTATION_FREE_DELIVERY = "SET_QUOTATION_FREE_DELIVERY";
export const SET_QUOTATION_GST_WAIVED = "SET_QUOTATION_GST_WAIVED";
export const SET_QUOTATION_USER = "SET_QUOTATION_USER";
export const SET_QUOTATION_USER_NEW_ADDRESS = "SET_QUOTATION_USER_NEW_ADDRESS";
export const SET_QUOTATION_LAST_CONTACT = "SET_QUOTATION_LAST_CONTACT";
export const SET_QUOTATION_PAYMENT_OBJECT = "SET_QUOTATION_PAYMENT_OBJECT";
export const SET_QUOTATION_PAYMENT_TERM_DAYS = "SET_QUOTATION_PAYMENT_TERM_DAYS";
export const SET_QUOTATION_PRODUCTS = "SET_QUOTATION_PRODUCTS";


// WEBPACK FOOTER //
// ./src/components/quotation/types.js